import type { ReactNode } from 'react';

import styles from './HowStartWorkBlock.module.scss';

interface IHowStartWorkBlockProps {
    imgSrc: string;
    title: ReactNode;
    text: string;
}

const HowStartWorkBlock: React.FC<IHowStartWorkBlockProps> = ({ imgSrc, title, text }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.wrapper_img}>
                <img src={imgSrc} alt={text} />
            </div>
            <div className={styles.wrapper_text}>
                <h3>{title}</h3>
                <p>{text}</p>
            </div>
            <div className={styles.wrapper_layout} />
        </div>
    );
};

export default HowStartWorkBlock;
